import {
  DEPOSITS_GET_ALL
} from '../types/actions.types';
import helper from '../../service/helper';
import { SET_ALL } from '../types/mutations.types';
import Deposits from '../../api/methods/Deposits';

const state = {
  pagination: {}
};

const getters = {
};

const actions = {
  async [DEPOSITS_GET_ALL] (vuex, { context, params } = {}) {
    try {
      const data = await Deposits.getAll(helper.clearObject({ ...params }));
      return Promise.resolve(data);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }
};

const mutations = {
  [SET_ALL] (state, { data, key }) {
    state[key] = data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
